import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { theme } from "../../../../../helpers/theme";
import { IconButton } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { deleteWarehousesImage } from "../../../../../services/warehouses-images/delete-image";
import { DeleteButton } from "./delete-button";
import { WarehousesGallery } from "../../../../../services/warehouses/get-all/types";

interface ActionBarProps {
  MagazynId: string;
  zdjecie_id: string;
  url: string;
  setImagesList: (imagesList: WarehousesGallery[]) => void;
  setIsGalleryLoading:(isGalleryLoading: boolean) => void;
}

export const ActionBar = ({ MagazynId, zdjecie_id, url,setImagesList,setIsGalleryLoading }: ActionBarProps) => {


  const downloadImage = (url: string) => {
    console.log(url);
    fetch(url, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "image.png"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <ActionBarWrapper>
     
     <DeleteButton MagazynId={MagazynId} zdjecie_id={zdjecie_id} url={url}  setImagesList={setImagesList} setIsGalleryLoading={setIsGalleryLoading}/>
      <div>
        <a
          //href={url ? url : undefined}
          //download
          onClick={() => downloadImage(url)}
          // onClick={()=>download()}
        >
          <IconButton
            sx={{ padding: "0px" }}
            aria-label="download"
            type="button"
            //  onClick={() => {
            //    console.log("Pobierz");
            // //   console.log(data.ubezpieczenie.url);

            //  }}
          >
            <DownloadForOfflineIcon
              sx={{
                color: `#008000`,
                ":hover": {
                  color: `${theme.colors.blue01_active}`,
                },
              }}
            />
          </IconButton>{" "}
        </a>
      </div>
    </ActionBarWrapper>
  );
};

const ActionBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${theme.colors.gray05_input};
  justify-content: flex-end;
`;
const DeleteButtonWrapper = styled.div``;
